module.exports = __webpack_public_path__ + "media/images/page/labo-logo-880a09f96aaebb1bc0ee4358bd458055.svg";